import "./DocView.scss"
import React, { useRef } from 'react'

import { renderAsync } from "docx-preview"
import { useEffect } from 'react';
import { urltoFile } from "../../utilities";
import { useState } from "react";

function DocView({ docxData }) {
  const [docx, setDocx] = useState(null)
  const containerRef = useRef(null)
  async function renderDocx() {
    await renderAsync(docx, containerRef.current, containerRef.current, {
      debug: true,
    })
  }

  async function init() {
    if (typeof docxData == 'string') {
      const fileFromUrl = await urltoFile(docxData, 'docxdoc', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document')
      setDocx(fileFromUrl)
      return
    }
    setDocx(docxData)
  }

  useEffect(() => {
    init()
  }, [])

  useEffect(() => {
    if (docx) {
      renderDocx()
    }
  }, [docx])

  return (
    <div className="DocView">
      <div ref={containerRef}></div>
    </div>
  )
}

export default DocView